import React from 'react';
import PropTypes from 'prop-types';
import Step from './Step';
import './StepperHorizontal.scss'


const propTypes={
    steps: PropTypes.array,
    activeStep: PropTypes.number,
};

export default class StepperHorizontal extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {

        const {steps, activeStep} = this.props;

        //console.log('active step', this.props.activeStep);

        return (
            <div className='stepper--root'>
                <div className='stepper-holder'>
                    {this.props.steps.map((step, index) => (
                        <Step
                            key={index}
                            title={step.title}
                            secondaryTitle={step.secondaryTitle}
                            index={index}
                            active={index === this.props.activeStep}
                            completed={index < this.props.activeStep}
                            first={index === 0}
                            isLast={index === steps.length - 1}
                            href={step.href}
                            onClick={step.onClick}
                        />
                    ))}
                </div>
            </div>
        )
    }
};

StepperHorizontal.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/StepperHorizontal/index.js